// extracted by mini-css-extract-plugin
export default {"labels":"TextArea_labels__sfStT","inputContainer":"TextArea_inputContainer__Xce77","contBoxes":"TextArea_contBoxes__no6sd","basicInputs":"TextArea_basicInputs__apWz+"};